
export function WhyChooseSection() {
  return (
    <section className="py-20 bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Por que escolher a Master?</h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Referência em detecção e reparo de vazamentos com tecnologia de ponta e atendimento humanizado.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="bg-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-all duration-300 animate-fade-in-up">
            <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-search-line text-2xl text-blue-800"></i>
            </div>
            <h3 className="text-xl font-semibold text-slate-900 mb-3">Diagnóstico sem quebra desnecessária</h3>
            <p className="text-slate-600 leading-relaxed">
              Utilizamos equipamentos de última geração para localizar o vazamento com precisão absoluta, evitando quebras desnecessárias.
            </p>
          </div>
          
          <div className="bg-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-all duration-300 animate-fade-in-up">
            <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-file-text-line text-2xl text-blue-800"></i>
            </div>
            <h3 className="text-xl font-semibold text-slate-900 mb-3">Laudo técnico aceito pela SABESP</h3>
            <p className="text-slate-600 leading-relaxed">
              Emitimos laudo técnico reconhecido pela SABESP para abatimento em conta de água e comprovação do reparo.
            </p>
          </div>
          
          <div className="bg-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-all duration-300 animate-fade-in-up">
            <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-shield-check-line text-2xl text-blue-800"></i>
            </div>
            <h3 className="text-xl font-semibold text-slate-900 mb-3">Garantia de 1 ano</h3>
            <p className="text-slate-600 leading-relaxed">
              Todos os nossos serviços possuem garantia de 1 ano, garantindo sua tranquilidade e a qualidade do trabalho realizado.
            </p>
          </div>
          
          <div className="bg-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-all duration-300 animate-fade-in-up">
            <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-time-line text-2xl text-blue-800"></i>
            </div>
            <h3 className="text-xl font-semibold text-slate-900 mb-3">Atendimento rápido</h3>
            <p className="text-slate-600 leading-relaxed">
              Equipe disponível para atendimento imediato em toda São Paulo e região metropolitana, 24h por dia.
            </p>
          </div>
          
          <div className="bg-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-all duration-300 animate-fade-in-up">
            <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-user-star-line text-2xl text-blue-800"></i>
            </div>
            <h3 className="text-xl font-semibold text-slate-900 mb-3">Profissionais experientes</h3>
            <p className="text-slate-600 leading-relaxed">
              Time altamente qualificado com anos de experiência e equipamentos modernos para todo tipo de vazamento.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}